import {Component, DoCheck, ElementRef, Input, ViewChild} from "@angular/core";
import {TranslateService} from "@ngx-translate/core";

@Component({
    selector: 'date-input',
    templateUrl: './date-input.component.html'
})
export class DateInputComponent implements DoCheck{
    public elementRef;
    @Input() placeholder: string;
    @Input() selected;
    @ViewChild('input') input: ElementRef;
    @Input() error: any;
    @Input() isDisabled: boolean;
    text: string;
    constructor(myElement: ElementRef,
                private translate: TranslateService){
        this.elementRef = myElement;
    }

    ngDoCheck(){
        if(this.placeholder == "from"){
            this.translate.get('restrictions.FROM', {}).subscribe((res: string) => {
                this.text = res;
            });
        }else if (this.placeholder == "to"){
            this.translate.get('restrictions.TO', {}).subscribe((res: string) => {
                this.text = res;
            });
        }
    }

    focus() {
        this.input.nativeElement.focus();
    }

    isInvalid() {
        return !!this.error;
    }

}


// WEBPACK FOOTER //
// ./public/upgrade/core/datepicker/date-input/date-input.component.ts